export default __webpack_public_path__ + "icon1a29453.svg";